import { IsInt, IsISO8601, IsOptional, IsString, Matches, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class ValidateStartEndDates {
    @IsOptional()
    @IsString()
    @IsISO8601()
    @Matches(/^\d{4}-\d{2}-\d{2}$/)
    public dateFrom: string;

    @IsOptional()
    @IsString()
    @IsISO8601()
    @Matches(/^\d{4}-\d{2}-\d{2}$/)
    public dateTo: string;
}

export class CountsOrdersToBePlaced {
    /*
    // add ability to send statuses from Client side. If needed in the future
        @IsOptional()
        @IsIn([ PurchaseOrderStatusEnum.NEW, PurchaseOrderStatusEnum.NOT_FINALISED, PurchaseOrderStatusEnum.READY_TO_BE_PLACED, PurchaseOrderStatusEnum.READY_TO_BE_PLACED_EDITED, PurchaseOrderStatusEnum.GOODS_IN_TRANSIT,
            PurchaseOrderStatusEnum.GOODS_RECEIVED_NO_OK, PurchaseOrderStatusEnum.CLOSED, PurchaseOrderStatusEnum.REFUSED, PurchaseOrderStatusEnum.TRANSFER_IN_TRANSIT, PurchaseOrderStatusEnum.CLOSED_AFTER_REOPENED, ],
            { each: true })
        @Type(() => Number)
        statuses: PurchaseOrderStatusEnum[];
    */
}
export class CountsOrdersToBeAuthorized {}
export class CountsOrdersToBeReceived {}
export class CountsOrdersTransfers {}
export class CountsOrdersCreditNotes {}
export class CountsOrdersCompleted extends ValidateStartEndDates {}


export class PurchaseOrderCountsDTO {
    @IsInt()
    @Type(() => Number)
    public merchantId: number;

    @IsInt()
    @Type(() => Number)
    public merchantGroupId: number;

    @Type(() => CountsOrdersToBePlaced)
    @ValidateNested()
    readonly ordersToBePlaced: CountsOrdersToBePlaced

    @Type(() => CountsOrdersToBeAuthorized)
    @ValidateNested()
    readonly ordersToBeAuthorized: CountsOrdersToBeAuthorized

    @Type(() => CountsOrdersToBeReceived)
    @ValidateNested()
    readonly ordersToBeReceived: CountsOrdersToBeReceived

    @Type(() => CountsOrdersTransfers)
    @ValidateNested()
    readonly ordersTransfers: CountsOrdersTransfers

    @Type(() => CountsOrdersCreditNotes)
    @ValidateNested()
    readonly ordersCreditNotes: CountsOrdersCreditNotes

    @Type(() => CountsOrdersCompleted)
    @ValidateNested()
    readonly ordersCompleted: CountsOrdersCompleted
}
